// react
import React from "react";
// styles
import { RestrictedItemSeperatorNodeText } from "./styles";
// constants
import { STATIC_TEXTS } from "@cart-client/constants/GiftingCart";

export const IMRestrictedItemSeperatorNode = () => {
    return (
        <RestrictedItemSeperatorNodeText variant="V2.body3.neutral.medium" color="warning">
            {STATIC_TEXTS.RESTRICTED_ITEM_SEPERATOR_NODE_TEXT}
        </RestrictedItemSeperatorNodeText>
    );
};
